/* eslint-disable camelcase */
import OpenApi3_1DereferenceStrategy from '@swagger-api/apidom-reference/dereference/strategies/openapi-3-1';
const compose = OpenApi3_1DereferenceStrategy.compose.bind();
export default compose;
/* eslint-enable camelcase */